export default () => ({
  profile: {
    description: null,
    estimatedMileage: null,
    vin: null,
    vrm: null
  },
  image: null
})
